<template>
  <div class="form-group">
    <slot name="label">
      <label v-if="label" class="control-label" :class="{ required: isRequired }">
        {{label}}
      </label>
      <img v-if="tooltip" v-tooltip="{content: tooltip, offset: 0}" src="@/assets/static/img/tooltip/tooltip.svg" alt="..."/>
    </slot>
    <select class="custom-select" v-model="model">
      <option disabled value="">{{ disabledValue }}</option>
      <option v-for="option in options" v-bind:key="option">{{ option }}</option>
    </select>
  </div>
</template>

<script>
  export default{
    name: "switch-group",
    props: {
      label: String,
      options: Array,
      tooltip: String,
      value: String,
      disabledValue: String,
      isRequired: Boolean,
    },
    computed: {
      model: {
        get () {
          return this.value
        },
        set (value) {
          this.$emit('input', value)
        }
      }
    },
  }
</script>